import { SuccessfullySubscribedComponent } from './../../components/successfully-subscribed/successfully-subscribed.component';
import { SignupPaymentSuccessComponent } from './../../components/signup-payment-success/signup-payment-success.component';
import { SignupSuccessfullyComponent } from './../../components/signup-successfully/signup-successfully.component';
import { FormGroup, FormBuilder, Validators, AbstractControl, FormArray } from '@angular/forms';
import { Component, Input, OnInit, ViewChild, NgZone, ElementRef } from '@angular/core';
import { MediaService } from 'src/app/shared/modules/services/media.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastService } from 'src/app/core/toast.service';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DetailsService } from 'src/app/modules/home/services/details.service';
import { SubscriptionPlansService } from 'src/app/modules/home/services/subscription-plans.service';
import { LogoutService } from './../../../../core/services/logout.service';
import { TermsPopUpComponent } from 'src/app/modules/home/components/terms-pop-up/terms-pop-up.component';
import { AuthService } from 'src/app/modules/home/services/auth.service';
import { SelectProfessionTypeComponent } from '../../components/select-profession-type/select-profession-type.component';
import { BusinessTyesService } from '../../services/business-tyes.service';
import { CommonService } from '../../services/common.service';
import { NextTabService } from '../../services/next-tab.service';
import { MapsAPILoader } from '@agm/core';
import { MustMatch } from '../../queries/passwordMatch';
//import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
//import {MomentDateAdapter} from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { DatePipe } from '@angular/common';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import * as _moment from 'moment';
import { default as _rollupMoment } from 'moment';
import { LoginReqComponent } from '../../components/login-req/login-req.component';
import { AddonsPaymentComponent } from 'src/app/modules/dashboard/modules/my-catalogues/pages/addons-payment/addons-payment.component';
import { CatalogueService } from 'src/app/modules/dashboard/modules/my-catalogues/services/catalogue.service';
import { SignupPlanPaymentsComponent } from '../../components/signup-plan-payments/signup-plan-payments.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { LoginService } from 'src/app/core/services/login.service';
import { trigger, transition, style, animate, query, stagger } from '@angular/animations';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { BasicInfoTabService } from 'src/app/modules/dashboard/modules/my-directory/services/basic-info-tab.service';
 
declare const google: any; // declare 'google' global object

const moment = _rollupMoment || _moment;
export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'DD-MM-YYYY',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};


@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss'],
  animations: [
    trigger('stepTransition', [
      transition(':increment', [
        query(':enter', [
          style({ transform: 'translateX(100%)', opacity: 0 }),
          animate('300ms ease-out', style({ transform: 'translateX(0)', opacity: 1 }))
        ], { optional: true }),
        query(':leave', [
          animate('300ms ease-out', style({ transform: 'translateX(-100%)', opacity: 0 }))
        ], { optional: true })
      ]),
      transition(':decrement', [
        query(':enter', [
          style({ transform: 'translateX(-100%)', opacity: 0 }),
          animate('300ms ease-out', style({ transform: 'translateX(0)', opacity: 1 }))
        ], { optional: true }),
        query(':leave', [
          animate('300ms ease-out', style({ transform: 'translateX(100%)', opacity: 0 }))
        ], { optional: true })
      ])
    ])
  ],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ]
})

export class SignupComponent implements OnInit {




  date = new FormControl(moment());
  currentStep: number = 1;
  typeBus:any;
  busineessTypesToggle:any;
  animationState = 0;
  subscription: any;
  passwordShow = false;
  confirmPassShow = false;
  fileTWoUrl: any
  showHide: boolean = false;
  btnShow :boolean = false;
  fileThreeUrl: any;
  signUpBlock: boolean = false
  personalBlock: boolean = true
  contactBlock: boolean = true
  profBlock: boolean = true
  otherBlock: boolean = true
  currentRole = 'ROLE_MODERATOR'
  filledDetails: any;
  PaidRecords = [];
  openpopup: boolean =false
  validDob = 0;
  initialValue = 18;
  // public latitude: number;
  //public longitude: number;
  //	public fillInAddress: '';
  //public searchControl: FormControl;
  //public zoom: number;
  //public f_addr: string;
  //public city: string;
  //public country: string;
  //public scountry: string;
  //public postCode: string;
  //public estab: string;
  //public state: string;
  //@ViewChild('message', { static: false })) messageElement: ElementRef;
  // @ViewChild('search',{ static: true }) searchElementRef: ElementRef;
  isCompletedOne: boolean = false
  isCompletedTwo: boolean = false
  isCompletedThree: boolean = false
  isCompletedFour: boolean = false
  bussObj = {
    name: null,
    status: null,
    sass_table_name: null
  }
  profObj = {
    date_of_birth: null,
    salutation: null,
    first_name: null,
    middle_name: null,
    last_name: null,
    profile_image: null,
    gender: null
  }
  contactProfObj = {
    alt_email: null,
    alt_phone: null,
    defaultAddress: null,
    address: {
      addressName: null,
      latitude: null,
      longitude: null,
      address_line_one: null,
      address_line_two: null,
      land_mark: null,
      city: null,
      state: null,
      country: null,
      zipcode: null
    }
  }
  profProfDetails = {
    profession_type: null,
    driving_licence: null,
    pro_details_aphra_registration_number: null,
    directory_category_id: null
  }
  profSupplierDetails = {
    profession_type: null,
    tga_number: null,
    //pro_details_aphra_registration_number:null,
    directory_category_id: null
  }
  profPracticeDetails = {
    profession_type: null,
    driving_licence: null,
    pro_details_aphra_registration_number: null,
    directory_category_id: null
  }
  signUpObjData = {
    name: null,
    password: null,
    email: null,
    type: null,
    phone: null,
    professionType: null,
    businessName: null,
    state:  null,
    postal_code: null,
    subscription_plan_id: null,
    payload: {
      subscriptionId: null
    },
    status: null,
  }
  subObj = {
    dental_supplier_id: null,
    dental_professional_id: null,
    dental_practice_id: null,
    subscription_plan_id: null,
    //client_id:null,
    //tenure_in_days:null,
    starts_at: null,
    expires_at: null,
    //status:null,
    plan_type: null,
    total_amount: null
  }
  profBankDetails = {
    bank_details: {
      bank_name: null,
      //branch_name: null,
      account_holder_name: null,
      account_number: null,
      bsb: null
    },
    second_hand: null,
  }
  supplierBankDetails = {
    bank_details: {
      bank_name: null,
      //branch_name: null,
      account_holder_name: null,
      account_number: null,
      bsb: null
    },
    second_hand: null,
    sell_products: null
  }
  practiceBankDetails = {
    bank_details: {
      bank_name: null,
      //branch_name: null,
      account_holder_name: null,
      account_number: null,
      bsb: null
    },
    second_hand: null,
  }
  detaultAddressPractice = {
    //addressName:null,
    dental_practice_id: null,
    latitude: null,
    longitude: null,
    line_1: null,
    line_2: null,
    landmark: null,
    city: null,
    state: null,
    country: null,
    postal_code: null,
    make_default: null,
    short_name: null
  }
  detaultAddressProfessional = {
    //addressName:null,
    dental_professional_id: null,
    latitude: null,
    longitude: null,
    line_1: null,
    line_2: null,
    landmark: null,
    city: null,
    state: null,
    country: null,
    postal_code: null,
    make_default: null,
    short_name: null
  }
  detaultAddress = {
    //addressName:null,
    dental_supplier_id: null,
    latitude: null,
    longitude: null,
    line_1: null,
    line_2: null,
    landmark: null,
    city: null,
    state: null,
    country: null,
    postal_code: null,
    make_default: null,
    short_name: null
  }
  contactSupplierObj = {
    alt_email: null,
    alt_phone: null,
    address: {
      addressName: null,
      latitude: null,
      longitude: null,
      address_line_one: null,
      address_line_two: null,
      land_mark: null,
      city: null,
      state: null,
      country: null,
      zipcode: null
    },
    first_name: null,
    middle_name: null,
    last_name: null,
    business_email: null,
    business_phone: null,
    fax_number: null,
    defaultAddress: null,
    secondary_contact: {
      name: null,
      email: null,
      phone: null
    }
  }
  contactPracticeObj = {
    alt_email: null,
    alt_phone: null,
    address: {
      addressName: null,
      latitude: null,
      longitude: null,
      address_line_one: null,
      address_line_two: null,
      land_mark: null,
      city: null,
      state: null,
      country: null,
      zipcode: null
    },
    first_name: null,
    middle_name: null,
    last_name: null,
    business_email: null,
    business_phone: null,
    fax_number: null,
    defaultAddress: null,
    secondary_contact: {
      name: null,
      email: null,
      phone: null
    }
  }
  supplierObj = {
    logo: null,
    abn_number: null,
    business_name: null,
    //subsciption_plan_id: null
  }
  practiceObj = {
    logo: null,
    abn_number: null,
    business_name: null
  }
  professinalObj = {
    dental_professional_id: null,
    special_interests: null,
    certifications: null,
    university_school: null,
    education: null,
    working_at: null,
    profession_type: null,
    name: null,
    awards: null,
    designation: null,
    type: null,
    directory_category_id: null,
    profile_image: null,
    banner_image: null,
    hobbies: null,
    email: null,
    phone: null,
    address: null,
    alt_phone: null,
    emergency_phone: null,
    latitude: null,
    longitude: null,
    pincode: null
  }
  dirObj = {
    company_name: null,
    description: null,
    directory_category_id: null,
    dental_practice_id: null,
    dental_professional_id: null,
    dental_supplier_id: null,
    //tags:null,
    type: null,
    banner_image: null,
    logo: null,
    email: null,
    phone: null,
    address: null,
    alt_phone: null,
    emergency_phone: null,
    latitude: null,
    longitude: null,
    pincode: null,
    name: null,
    profession_type: null,
    abn_acn: null


  }
  countryName: any;
  stateName: any;
  addressName: any;
  pincode: any;
  professionId: any;
  latitude: any;
  longitude: any;
  //userDp:any;
  fileName: any;
  fileUrl: any;
  userFilesCount = []
  urlsw: any = [];
  leadId: any;
  payload = {
    subscriptionId: null
  }
  subPlanDetails: any;
  userPhoto: any;
  signUpData = {
    payload: null,
    profile_status: false
  }
  //toggle:boolean = true;
  businessPhoto: any;
  selectControl = this._fb.control("SIGNUP");
  personalDetailsPayload: any;
  contactDetailsPayload: any;
  signUpDetailsForm: FormGroup;
  subscriberDetailForm: FormGroup;
  contactInformationForm: FormGroup;
  professionalDetailsForm: FormGroup;
  otherDetailsForm: FormGroup;  
  directoryAddForm: FormGroup;
  signUpDetails = false;
  personalDetailsForm = false;
  contactDetailsForm = false;
  professionalDetails = false;
  otherDetails = false;
  incompletelogin : any;
  static nextId: number = 0;
  leadResponce: any;
 
  // nextUniqueId = `profile-image-${ProfileComponent.nextId}`;
  mimeArray: string[] =
    ['image/jpg',
      'image/jpeg',
      'image/png',
      'image/gif',
      'image/vnd.microsoft.icon',
      'image/svg+xml',
      'image/tiff',
      'image/webp'];
  @Input() fileInput: FormControl;
  @Input() size: number;
  @Input() isDimensionCheck: boolean;
  @Input() width: number;
  @Input() height: number;
  
  isHovering: boolean;
  progress = 0;
  @ViewChild('fileVariable') fileInputRef: ElementRef;
  busineesTypes: any;
  professinalPayload: any;
  clientStatus = {
    status: null
  }
  private geoCoder;
  zoom: any;
  tgaFlip: boolean = true;
  tgaFlipcheck: boolean = false;
  tabFliperror:any;
  loginData: any;
  phoneRegex = new RegExp(/^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,5})|(\(?\d{2,6}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/);
  emailRegex = new RegExp(
    /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
  );
  userName: any;
  othersTypes: any;
  //@ViewChild('search', { static: false })
  //userName:any;
  //othersTypes:any;
  specificLength = 3;
  maxDate = new Date();
  userPrice:any;
  priceEx:any;
  termAndConditionCheck:any;
  dentalData: any;
  // @ViewChild('search',{static:false})
  // public searchElementRef: ElementRef;
  constructor(
    private _fb: FormBuilder,
    private authService: AuthService,
    private detailsService: DetailsService,
    private mediaService: MediaService,
    private activeRoute: ActivatedRoute,
    private subscriptionPlansService: SubscriptionPlansService,
    private logoutService: LogoutService,
    private toast: ToastService,
    private _dialog: MatDialog,
    private businessTyesService: BusinessTyesService,
    private commonService: CommonService,
    private router: Router,
    private nextTabService: NextTabService,
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    private catalogueService: CatalogueService,
    private spinner: NgxSpinnerService,
    private loginService: LoginService,
    private basicInfoTabService: BasicInfoTabService
    //private modalService: NgbModal
  ) { }


  ngOnInit(): void {

    this.initializeForm();
  // Watch for changes to professionType








    //localStorage.setItem('signupstep', '5')
    this.userPrice = localStorage.getItem('selPrice');
    //console.log(this.userPrice)
    this.priceEx = localStorage.getItem('disValue');

    this.termAndConditionCheck = localStorage.getItem('termAndCondition');


    localStorage.removeItem('contactInfo');
    localStorage.removeItem('contactmainaddress');
    localStorage.removeItem('userProf');
 //   this.logoutService.logout();
    this.logoutService.logoutOnSignup();

   //console.log(localStorage.getItem("signupstep"))
   //console.log(localStorage.getItem("incompletelogin"))
   this.incompletelogin =localStorage.getItem("incompletelogin"); 
    
    this.subscription = this.commonService.on('call-parent').subscribe(() => this.showProfessionalDetailsForm());
    this.subscription = this.commonService.on('call-back').subscribe(() => this.backToPersonal());

    this.loginData = this.loginService.getLoginData()    
    if(!this.loginData){
      var log = localStorage.getItem('logInfo');
      this.loginData = JSON.parse(log);
    }

    if(!this.loginData){
      this.signUpDetails = true;
    }

    console.log('Login Info--->',this.loginData)

    this.activeRoute.params.subscribe((params) => { 
      
      this.subscriptionPlansService.getSubPlanById(params.id).subscribe(data => {
        // this.spinner.hide();
        //console.log(this.loginData.type)
        console.log('Sub Plan Details--->',data)
        this.signUpBlock = true
        this.subPlanDetails = data
        this.subPlanDetails.price_in_aud = JSON.parse(this.userPrice)
        this.subPlanDetails.priceExten = this.priceEx
        //console.log(params.leadId)
        //console.log(this.subPlanDetails)
        this.leadId = params.leadId
        console.log('Lead Id-->', this.leadId);
        if (this.loginData?.id) {
        
          
          if (this.loginData.type == "PROFESSIONAL") {
           // console.log(this.loginData.type)
            this.nextTabService.getUserProfDetails(this.loginData.id).subscribe(data => {
              //console.log(data)
              this.filledDetails = data
              this.subscriberDetailForm.patchValue({
                salutation: this.filledDetails.salutation,
                first_name: this.filledDetails.first_name,
                last_name: this.filledDetails.last_name,
                //first_name:this.filledDetails.abn_number,
                middle_name: this.filledDetails.middle_name,
                dob: this.filledDetails.date_of_birth,
                gender: this.filledDetails.gender,
                //first_name:this.filledDetails.abn_number
              });


              this.userPhoto = this.filledDetails.profile_image

             

              if (!this.loginData.gender) {
                this.selectControl.setValue("PERSONAL")
                this.showPersonalDetailsForm()
                this.isCompletedOne = true
              } else if (!this.loginData.address) {
                this.selectControl.setValue("CONTACT")
                this.showContactDetailsForm()
                this.isCompletedOne = true
                this.isCompletedTwo = true
                //this.showContactDetailsForm()
              } else {
                for (let one of this.filledDetails.user_subscriptions) {
                  if (one.payment_status == "PAID") {
                    this.PaidRecords.push(one)
                  }
                }
                if (this.PaidRecords.length) {
                  this.selectControl.setValue("OTHER")
                  this.showOtherDetailsForm()
                  this.isCompletedOne = true
                  this.isCompletedTwo = true
                  this.isCompletedThree = true
                  this.isCompletedFour = true
                } else {
                  this.selectControl.setValue("PROFESSIONAL")
                  this.showProfessionalDetailsForm()
                  this.isCompletedOne = true
                  this.isCompletedTwo = true
                  this.isCompletedThree = true
                }
              }


            });
          }
          if (this.loginData.type == "SUPPLIER") {


            if (this.leadId && this.subPlanDetails.price_in_aud !== 0) {
              this._dialog.open(SignupPlanPaymentsComponent, {
                width: '30%',
                panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
                disableClose: true,
                data: {
                  leadId: this.leadId,
                  planDetails: this.subPlanDetails
                }
              })
            }else{
              this.signUpDetails = true;
            }
           
          }
         

          if (this.loginData.type == "PRACTICE") {
            this.nextTabService.getUserPracticeDetails(this.loginData.id).subscribe(data => {
              console.log(data)
              console.log('Rk test')
              this.filledDetails = data
              this.subscriberDetailForm.patchValue({
                businessName: this.filledDetails.business_name,
                ABN_ACN_number: this.filledDetails.abn_number
              });
              this.businessPhoto = this.filledDetails.logo

              if (!this.loginData.business_name) {
                this.selectControl.setValue("PERSONAL")
                this.showPersonalDetailsForm()
                this.isCompletedOne = true
              } else if (!this.loginData.address) {
                this.selectControl.setValue("CONTACT")
                this.showContactDetailsForm()
                this.isCompletedOne = true
                this.isCompletedTwo = true
              } else {
                console.log(this.filledDetails)
                for (let one of this.filledDetails.user_subscriptions) {
                  if (one.payment_status == "PAID") {
                    this.PaidRecords.push(one)
                  }
                }
                console.log(this.PaidRecords)
                if (this.PaidRecords.length) {
                  this.selectControl.setValue("OTHER")
                  this.showOtherDetailsForm()
                  this.isCompletedOne = true
                  this.isCompletedTwo = true
                  this.isCompletedThree = true
                  this.isCompletedFour = true
                } else {
                  this.selectControl.setValue("PROFESSIONAL")
                  this.showProfessionalDetailsForm()
                  this.isCompletedOne = true
                  this.isCompletedTwo = true
                  this.isCompletedThree = true
                }
                // this.selectControl.setValue("PROFESSIONAL")
                // this.showProfessionalDetailsForm()
                // this.isCompletedOne = true
                // this.isCompletedTwo = true
                // this.isCompletedThree = true
              }

            });
          }
          // if (this.loginData.type == "PROFESSIONAL") {
       
          // } else {
            
          // }
        } else if (params.leadId && !this.loginData?.id) {
          
          this.nextTabService.getUser(params.leadId).subscribe(data => {
            console.log(data)
            this.userName = data
            this.subscriberDetailForm.patchValue({
              first_name: this.userName.name,
            });
            this.contactInformationForm.patchValue({
              fName: this.userName.name
            });
          });
          this.clientStatus.status = "UNBLOCKED"
          this.nextTabService.updateClientStatus(params.leadId, this.clientStatus).subscribe(data => {
            console.log(data)
          });


          // this.selectControl.setValue("CONTACT")
          // this.showContactDetailsForm()
          // this.isCompletedTwo = true
          this.selectControl.setValue("PERSONAL")
          this.showPersonalDetailsForm()
          this.isCompletedOne = true
          //console.log('Rk working now');
          // this.selectControl.setValue("PERSONAL")
          

          if(localStorage.getItem("signupstep")=='2'){
            this.showPersonalDetailsForm()
            this.isCompletedOne = true
            this.isCompletedTwo = true
 
          }else if(localStorage.getItem("signupstep")=='3'){
            this.showContactDetailsForm()
            this.isCompletedOne = true
            this.isCompletedTwo = true
            this.isCompletedThree = true
 
          }else if(localStorage.getItem("signupstep")=='4'){
            this.showProfessionalDetailsForm()
            this.isCompletedOne = true
            this.isCompletedTwo = true
            this.isCompletedThree = true
            this.isCompletedFour=true
     
          }else if(localStorage.getItem("signupstep")=='5'){
            this.showOtherDetailsForm()
            this.isCompletedOne = true
            this.isCompletedTwo = true
            this.isCompletedThree = true
            this.isCompletedFour=true
    
          }else{
          this.showPersonalDetailsForm()
          this.isCompletedOne = true
          }
          
          //this.isCompletedTwo = true
          // console.log(params.leadId)
          // console.log("oooooooooooooooooooo")
          // setTimeout(() => {
          //   /** spinner ends after 5 seconds */
          //   this.selectControl.setValue("PERSONAL")
          //   this.showPersonalDetailsForm()
          // }, 5000);
        }
        //this.doctorDetails=data
        console.log(this.subPlanDetails.type)
        this.businessTyesService.getBusinessTYpes(this.subPlanDetails.type).subscribe(data => {
          console.log(data)
          this.busineesTypes = data
        });
      })
    })
    // this.toggle = true
    this.commonService.data.subscribe(nestTab => {
      this.selectControl.setValue("OTHER")
      this.showOtherDetailsForm()
      this.isCompletedFour = true
    })
    this.signUpDetailsForm = this._fb.group({
      name: [null, [Validators.required, Validators.pattern('.*\\S.*[a-zA-Z,./-0-9  ]')]],
      email: [null, [Validators.required, Validators.email]],
      phone: [null, [Validators.required,Validators.pattern(/^[0-9]{10}$/)]],
      password: [null, [Validators.required, Validators.minLength(6)]],
      confirmPassword: [null, [Validators.required]],
      professionType: [null, [Validators.required]],
      businessName: [null],
      state: [null, [Validators.required]],
      postal_code: [null, [Validators.required]],
       customBusinessType: [''],
     
    }, { validator: [this.passwordMatchValidator,this.professionOrCustomValidator.bind(this)]
    }
    );
    console.log('Form initialized:', this.signUpDetailsForm);

    this.subscriberDetailForm = this._fb.group({
      salutation: [null, [Validators.required]],
      first_name: [null, [Validators.required, Validators.pattern('.*\\S.*[a-zA-Z,./-0-9  ]')]],
      last_name: [null, [Validators.required, Validators.pattern('.*\\S.*[a-zA-Z,./-0-9  ]')]],
      middle_name: [null],
      dob: [null, [Validators.required]],
      gender: [null, [Validators.required]],
      profile_image: [null],
      businessLogo: [null],
      businessName: [null, [Validators.required, Validators.pattern('.*\\S.*[a-zA-Z,./-0-9  ]')]],
      ABN_ACN_number: [null, [Validators.required, Validators.pattern('^[0-9]*$')]],
    });
    this.contactInformationForm = this._fb.group({
      fName: [null, [Validators.required, Validators.pattern('.*\\S.*[a-zA-Z,./-0-9  ]')]],
      lName: [null, [Validators.required, Validators.pattern('.*\\S.*[a-zA-Z,./-0-9  ]')]],
      mName: [null, [Validators.required, Validators.pattern('.*\\S.*[a-zA-Z,./-0-9  ]')]],
      businessPhoneNumber: [null, [Validators.required, Validators.pattern(this.phoneRegex)]],
      //emailtwo: [null, [Validators.required]],
      altEmail: [null, [Validators.pattern(this.emailRegex)]],
      //phoneNo: [null, [Validators.required]],
      altPhoneNo: [null, [Validators.pattern(this.phoneRegex)]],
      address_line_one: [null],
      address_line_two: [null],
      land_mark: [null],
      city: [null, [Validators.required, Validators.pattern('.*\\S.*[a-zA-Z,./-0-9  ]')]],
      state: [null, [Validators.required]],
      country: [null, [Validators.required]],
      zipcode: [null, [Validators.required]],
      address: [null, [Validators.required]],
      businessEmail: [null, [Validators.required, Validators.pattern(this.emailRegex)]],
      faxNumber: [null],
      emailTwo: [null, [Validators.pattern(this.emailRegex)]],
      phoneNoTwo: [null, [Validators.pattern(this.phoneRegex)]],
      contactName: [null, [, Validators.pattern('.*\\S.*[a-zA-Z,./-0-9  ]')]],
    });
    this.professionalDetailsForm = this._fb.group({
      professionType: [null, [Validators.required]],
      pro_details_aphra_registration_number: ['DEN', [Validators.required, Validators.minLength(13), Validators.maxLength(13)]],
      //pro_details_aphra_registration_number: [null,[]],
      drivingLicense: [null, []],
      tga: [null, []],
      // dentalCertificate: [null, [Validators.required]],
      // hourly_charge_in_aud: [null, [Validators.required]],
      // hourly_charge_in_usd: [null, [Validators.required]],
      // areas_of_interest: [null, [Validators.required]],
      // registration_certificate_attachment: [null, , [Validators.required]],
      // doctorLicense: [null, [Validators.required]],
      // resume_attachment: [''],
      // bank_name: [null, [Validators.required]],
      // branch_name: [null, [Validators.required]],
      // account_holder_name: [null, [Validators.required]],
      // account_number: [null, [Validators.required]],
      // bsb: [null, [Validators.required, Validators.minLength(6), Validators.maxLength(6)]],
    });
    this.otherDetailsForm = this._fb.group({
      sellSecondHandSupplies: [false],
      sellProducts: [false],
      bank_name: [null],
      //branch_name: [null, [Validators.required]],
      account_holder_name: [null],
      account_number: [null],
      bsb: [null]
    });
    this.businessTyesService.data.subscribe(scrollData => {
      console.log('Select resp-->',scrollData)
      if (scrollData.otherName == "otherCat") {
        this.professionalDetailsForm.get('pro_details_aphra_registration_number').clearValidators();
        //this.subscriberDetailForm.get('businessName').clearValidators();
        this.professionalDetailsForm.get('pro_details_aphra_registration_number').updateValueAndValidity();
      }
      if(
        ['Dental Hygienist', 'Dentist', 'Dental Prosthetist', 'Dental Therapist', 'Dental Specialist'].includes(scrollData.name)
      ) {
        this.professionalDetailsForm.get('pro_details_aphra_registration_number').setValidators([Validators.required, Validators.minLength(13), Validators.maxLength(13)]);
        this.professionalDetailsForm.get('pro_details_aphra_registration_number').updateValueAndValidity();
      } else {
        this.professionalDetailsForm.get('pro_details_aphra_registration_number').clearValidators();
        this.professionalDetailsForm.get('pro_details_aphra_registration_number').updateValueAndValidity();
      }
      this.professionId = scrollData.id
      this.signUpDetailsForm.patchValue({
        professionType: scrollData.name
      })
      //window.scroll(0,0);
      // setTimeout(() => {
      //   this.vps.scrollToAnchor("scrollPage");
      // }, 1000);
    })
    this.directoryAddForm = this._fb.group({
      //profession:[null, [Validators.required]],
      directory_category_id: [null],
      company_name: [null],
      //category: [null, [Validators.required]],
      //name: [null, [Validators.required]],
      description: [null],
      //status: [null, [Validators.required]],
      //phoneNo: [null, [Validators.required]],
      //email: [null, [Validators.required]],
      //area: [null, [Validators.required]],
      //tags: [null, [Validators.required]],
      abn_number: [null],
      banner_image: [null],
      alternative_phone: [null],
      phone: [null],
      email: [null],
      logo: [null],
      //special_interests:[null],
      address: [null],
      hobbies: this._fb.array([]),
      education: this._fb.array([]),
      working_at: this._fb.array([]),
      //certifications:[null],
      university_school: this._fb.array([]),	
      profession_type: [null],
      name: [null],
      // awards:[null],
      designation: [null],
      //image:[null, [Validators.required]],
      //qualification: [null, [Validators.required]],
      colorCtr: [],
    })
    this.nextTabService.data.subscribe(scroll => {
      console.log(scroll)
      this.selectControl.setValue("PERSONAL")
      this.showPersonalDetailsForm()
    })
    this.commonService.data.subscribe(nextTab => {
      console.log(nextTab)
      this.selectControl.setValue("OTHER")
      this.showOtherDetailsForm()
      this.isCompletedFour = true
    })
    
  }
 
  initializeForm() {
    this.signUpDetailsForm = this._fb.group({
      name: [null, [Validators.required, Validators.pattern('.*\\S.*[a-zA-Z,./-0-9  ]')]],
      email: [null, [Validators.required, Validators.email]],
      phone:[null, [Validators.required,Validators.pattern(/^[0-9]{10}$/)]],
      password: [null, [Validators.required, Validators.minLength(6)]],
      confirmPassword: [null, [Validators.required]],
      professionType: [null],
      businessName: [null],
      state: [null, [Validators.required]],
      postal_code: [null, [Validators.required]],
      customBusinessType: ['']
    }, { 
      validators: [
        this.passwordMatchValidator.bind(this),
        this.professionOrCustomValidator.bind(this)
      ]
    });
      // Add value changes subscriptions
  this.signUpDetailsForm.get('password').valueChanges.subscribe(() => {
    this.checkPasswordMatch();
  });

  this.signUpDetailsForm.get('confirmPassword').valueChanges.subscribe(() => {
    this.checkPasswordMatch();
  });
  }
  checkPasswordMatch() {
    const isMatch = this.password.value === this.confirmPassword.value;
    if (!isMatch) {
      this.confirmPassword.setErrors({ mismatch: true });
    } else if (this.confirmPassword.errors?.mismatch) {
      this.confirmPassword.setErrors(null);
    }
  }
  loadbusinessType(){
    
    console.log('Business Types--->1111', this.busineesTypes)
/**** profession type */
this.typeBus =  this.busineesTypes

/**** profession type end */
  }

  showSignUpDetailsForm() {
    this.signUpDetails = true;
    this.personalDetailsForm = false;
    this.contactDetailsForm = false;
    this.professionalDetails = false;
    this.otherDetails = false;
  }
  showPersonalDetailsForm(): void {
    this.signUpDetails = false;
    this.personalDetailsForm = true;
    this.contactDetailsForm = false;
    this.professionalDetails = false;
    this.otherDetails = false;
  }
  showContactDetailsForm(): void {
    // this.clickToCall()
    this.signUpDetails = false;
    this.personalDetailsForm = false;
    this.contactDetailsForm = true;
    this.professionalDetails = false;
    this.otherDetails = false;
  }
  showProfessionalDetailsForm(): void {
    this.signUpDetails = false;
    this.personalDetailsForm = false;
    this.contactDetailsForm = false;
    this.professionalDetails = true;
    this.otherDetails = false;
    this.isCompletedThree = true;
    this.selectControl.setValue("PROFESSIONAL")
  }
  showOtherDetailsForm(): void {
    this.signUpDetails = false;
    this.personalDetailsForm = false;
    this.contactDetailsForm = false;
    this.professionalDetails = false;
    this.otherDetails = true;
  }

  passwordMatchValidator(frm: FormGroup) {
    return frm.controls['password'].value === frm.controls['confirmPassword'].value 
      ? null : { 'mismatch': true };
  }
  professionOrCustomValidator(group: FormGroup) {
      if (!this.subPlanDetails) {
    return null;
  }
    const professionType = group.get('professionType').value;
    const customType = group.get('customBusinessType').value;
    
    // If using business types (Supplier/Practice)
    if (this.subPlanDetails?.type === 'SUPPLIER' || this.subPlanDetails?.type === 'PRACTICE') {
      if (!group.get('businessName').value) {
        return { businessNameRequired: true };
      }
    }
    
    // Check either professionType or customBusinessType is filled
    if (!professionType && !customType) {
      return { professionOrCustomRequired: true };
    }
    
    return null;
  }
  get name(): AbstractControl {
    return this.signUpDetailsForm.get('name');
  }
  get email(): AbstractControl {
    return this.signUpDetailsForm.get('email');
  }
  get phone(): AbstractControl {
    return this.signUpDetailsForm.get('phone');
  }
  get password(): AbstractControl {
    return this.signUpDetailsForm.get('password');
  }
  get confirmPassword(): AbstractControl {
    return this.signUpDetailsForm.get('confirmPassword');
  }
  get professionType(): AbstractControl {
    return this.signUpDetailsForm.get('professionType');
  }

  get businessName(): AbstractControl {
    return this.signUpDetailsForm.get('businessName');
  }
  get customBusinessType() { return this.signUpDetailsForm.get('customBusinessType'); }

  get state(): AbstractControl {
    return this.signUpDetailsForm.get('state');
  }
  get postal_code(): AbstractControl {
    return this.signUpDetailsForm.get('postal_code');
  }
  get type(): AbstractControl {
    return this.signUpDetailsForm.get('type');
  }
  viewPassword() {
    this.passwordShow = !this.passwordShow;
  }
  viewCinfirmPassword() {
    this.confirmPassShow = !this.confirmPassShow
  }
  get salutation(): AbstractControl {
    return this.subscriberDetailForm.get('salutation');
  }
  get first_name(): AbstractControl {
    return this.subscriberDetailForm.get('first_name');
  }
  get last_name(): AbstractControl {
    return this.subscriberDetailForm.get('last_name');
  }
  get middle_name(): AbstractControl {
    return this.subscriberDetailForm.get('middle_name');
  }
  // get businessLogo(): AbstractControl {
  //   return this.subscriberDetailForm.get('businessLogo');
  // }
  get dob(): AbstractControl {
    return this.subscriberDetailForm.get('dob');
  }
  get gender(): AbstractControl {
    return this.subscriberDetailForm.get('gender');
  }
  /*get businessName(): AbstractControl {
    return this.subscriberDetailForm.get('businessName');
  }*/
  get ABN_ACN_number(): AbstractControl {
    return this.subscriberDetailForm.get('ABN_ACN_number');
  }
  get fName(): AbstractControl {
    return this.contactInformationForm.get('fName');
  }
  get lName(): AbstractControl {
    return this.contactInformationForm.get('lName');
  }
  get mName(): AbstractControl {
    return this.contactInformationForm.get('mName');
  }
  get businessPhoneNumber(): AbstractControl {
    return this.contactInformationForm.get('businessPhoneNumber');
  }
  get businessEmail(): AbstractControl {
    return this.contactInformationForm.get('businessEmail');
  }
  get faxNumber(): AbstractControl {
    return this.contactInformationForm.get('faxNumber');
  }
  get contactName(): AbstractControl {
    return this.contactInformationForm.get('contactName');
  }
  get phoneNoTwo(): AbstractControl {
    return this.contactInformationForm.get('phoneNoTwo');
  }
  get emailTwo(): AbstractControl {
    return this.contactInformationForm.get('emailTwo');
  }
  get altEmail(): AbstractControl {
    return this.contactInformationForm.get('altEmail');
  }
  get phoneNo(): AbstractControl {
    return this.contactInformationForm.get('phoneNo');
  }
  get altPhoneNo(): AbstractControl {
    return this.contactInformationForm.get('altPhoneNo');
  }
  get address_line_one(): AbstractControl {
    return this.contactInformationForm.get('address_line_one');
  }
  get address_line_two(): AbstractControl {
    return this.contactInformationForm.get('address_line_two');
  }
  get zipcode(): AbstractControl {
    return this.contactInformationForm.get('zipcode');
  }
  get land_mark(): AbstractControl {
    return this.contactInformationForm.get('land_mark');
  }
  get city(): AbstractControl {
    return this.contactInformationForm.get('city');
  }
  /*get state(): AbstractControl {
    return this.contactInformationForm.get('state');
  }*/
  get address(): AbstractControl {
    return this.contactInformationForm.get('address');
  }
  get country(): AbstractControl {
    return this.contactInformationForm.get('country');
  }
  /*get professionType(): AbstractControl {
    return this.professionalDetailsForm.get('professionType');
  }*/
  get pro_details_aphra_registration_number(): AbstractControl {
    return this.professionalDetailsForm.get('pro_details_aphra_registration_number');
  }
  get drivingLicense(): AbstractControl {
    return this.professionalDetailsForm.get('drivingLicense');
  }
  get dentalCertificate(): AbstractControl {
    return this.professionalDetailsForm.get('dentalCertificate');
  }
  get hourly_charge_in_aud(): AbstractControl {
    return this.professionalDetailsForm.get('hourly_charge_in_aud');
  }
  get hourly_charge_in_usd(): AbstractControl {
    return this.professionalDetailsForm.get('hourly_charge_in_usd');
  }
  get areas_of_interest(): AbstractControl {
    return this.professionalDetailsForm.get('areas_of_interest');
  }
  get tga(): AbstractControl {
    return this.professionalDetailsForm.get('tga');
  }
  get registration_certificate_attachment(): AbstractControl {
    return this.professionalDetailsForm.get('registration_certificate_attachment');
  }
  get doctorLicense(): AbstractControl {
    return this.professionalDetailsForm.get('doctorLicense');
  }
  get resume_attachment(): AbstractControl {
    return this.professionalDetailsForm.get('resume_attachment');
  }
  get bank_name(): AbstractControl {
    return this.otherDetailsForm.get('bank_name');
  }
  get account_holder_name(): AbstractControl {
    return this.otherDetailsForm.get('account_holder_name');
  }
  get account_number(): AbstractControl {
    return this.otherDetailsForm.get('account_number');
  }
  get bsb(): AbstractControl {
    return this.otherDetailsForm.get('bsb');
  }

  get sellProducts(): AbstractControl {
    return this.otherDetailsForm.get('sellProducts');
  }

  get sellSecondHandSupplies(): AbstractControl {
    return this.otherDetailsForm.get('sellSecondHandSupplies');
  }

  
  
  


  backToSignUp() {
  
    this.selectControl.setValue("SIGNUP")
    this.signUpDetails = true;
    this.personalDetailsForm = false;
    this.contactDetailsForm = false;
    this.professionalDetails = false;
    localStorage.setItem('signupstep', '1');
  }
  backToPersonal() {
    this.selectControl.setValue("PERSONAL")
    this.signUpDetails = false;
    this.personalDetailsForm = true;
    this.contactDetailsForm = false;
    this.professionalDetails = false;

    localStorage.setItem('signupstep', '2');
    this.isCompletedTwo = true
    this.isCompletedThree = false
    this.isCompletedFour = false
    // this.subscriberDetailForm.{
    //   businessLogo : "img"
    // })
  }
  backToContact() {
    this.selectControl.setValue("CONTACT")
    this.signUpDetails = false;
    this.personalDetailsForm = false;
    this.contactDetailsForm = true;
    this.professionalDetails = false;

    localStorage.setItem('signupstep', '3');
    this.isCompletedTwo = true
    this.isCompletedThree = true
    this.isCompletedFour = false
  }


  checkboxValue(){
    this.termAndConditionCheck = (<HTMLInputElement>document.getElementById("termAndCondition")).checked;
    localStorage.setItem('termAndCondition', 'true'); 
  }


/****for step form */
// Navigation methods
nextStep() {
  // First mark all controls as touched to show errors
  this.signUpDetailsForm.markAllAsTouched();

  if (this.isStepValid(this.currentStep)) {
    this.animationState++;
    this.currentStep++;
    
    // Load business types when moving to step 2
    if (this.currentStep === 2) {
      this.loadbusinessType();
    }
  } else {
    console.log('Current step invalid:', {
      step: this.currentStep,
      name: this.name.valid,
      email: this.email.valid,
      phone: this.phone.valid,
      password: this.password.valid,
      confirmPassword: this.confirmPassword.valid,
      professionType: this.professionType.valid,
      customBusinessType: this.customBusinessType.valid,
      businessName: this.businessName.valid,
      state: this.state.valid,
      postal_code: this.postal_code.valid
    });
  }
}

previousStep() {
  this.animationState--;
  this.currentStep--;
}

goToStep(step: number) {
  // Only allow navigation to completed steps or the next step
  if (step < this.currentStep || (step === this.currentStep + 1 && this.isStepValid(this.currentStep))) {
    this.animationState = step;
    this.currentStep = step;
  }
}

// Validation method
isStepValid(step: number): boolean {
  switch(step) {
    case 1: // Basic Info Step
      const isPasswordMatch = this.password.value === this.confirmPassword.value;

      return (
        this.name.valid &&
        this.email.valid &&
       
        this.password.valid &&
        this.confirmPassword.valid &&
        isPasswordMatch
      );

    case 2: // Profession Type Step
      // For Supplier/Practice, check businessName
      if (this.subPlanDetails?.type === 'SUPPLIER' || this.subPlanDetails?.type === 'PRACTICE') {
        if (!this.businessName.valid) return false;
      }
      
      // Check either professionType OR customBusinessType is valid
      return (
        this.professionType.valid || 
        (this.customBusinessType.valid && this.customBusinessType.value)
      );

    case 3: // Location Step
      return (
        this.state.valid && 
        this.postal_code.valid &&  
        this.phone.valid
      );

    default:
      return false;
  }
}
  
// Modify your existing signUp method to handle the final submission
signUp(signupFormClear: any) {
  this.signUpDetailsForm.markAllAsTouched();
  console.log('Form submission initiated');
  console.log('Form valid:', this.signUpDetailsForm.valid);
  console.log('Form errors:', this.signUpDetailsForm.errors);
  console.log('Form value:', this.signUpDetailsForm.value);

  if (this.signUpDetailsForm.invalid) {
    console.log('Form errors:', this.signUpDetailsForm.errors);
    return;
  }

  if (this.signUpDetailsForm.value.password !== this.signUpDetailsForm.value.confirmPassword) {
    this.toast.openSnackBar('Password and confirm password must be same');
    return;
  }

  if (!this.termAndConditionCheck) {
    this.toast.openSnackBar('Agree to Terms and Conditions');
    return;
  }

 // Get form values
 const formValues = this.signUpDetailsForm.value;

 // Prepare submission data
 const submissionData = {
  name: formValues.name,
  email: formValues.email,
  phone: formValues.phone,
  password: formValues.password,
  state: formValues.state,
  business_name:formValues.businessName,
  postal_code: formValues.postal_code,
  professionType: formValues.customBusinessType || formValues.professionType,
  subscription_plan_id: this.subPlanDetails?.id,
  status: this.subPlanDetails?.type === 'SUPPLIER' ? 'BLOCKED' : 'PENDING',
  type: this.subPlanDetails?.type,
  payload: { subscriptionId: this.subPlanDetails?.id }
};
 

  console.log('Submitting:', submissionData);
  
   
  this.authService.register(submissionData).then(data => {
    console.log('Registration successful:', data);
    this.leadResponce = data;
    
    if (data) {
      this.isCompletedOne = true;
      signupFormClear.resetForm();
      
      this._dialog.open(SignupSuccessfullyComponent, {
        width: '30%',
        panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
        disableClose: true,
        data: data
      });
    }
    
    console.log('New lead ID:', data.id);
    this.leadId = data.id;
    localStorage.setItem('signupstep', '2'); 
  })
}

/*** google sign up */

signInWithGoogleExt() {
  const client = google.accounts.oauth2.initTokenClient({
    client_id: '954492858791-r7kjqgbhsmlojthtmv02tfiub70brbhl.apps.googleusercontent.com', // your client ID
    scope: 'profile email',
    callback: (tokenResponse: any) => {
      console.log('Token Response:', tokenResponse);
      this.fetchUserInfo(tokenResponse.access_token);
    }
  });

  client.requestAccessToken();
}

fetchUserInfo(accessToken: string) {
  // Now fetch user profile info with accessToken
  fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  })
  .then(response => response.json())
  .then(user => {
    console.log('Google User Info:', user);

    const submissionData = {
      name: user.name,
      email: user.email,
      password: 'GOOGLE_AUTH', // placeholder password
      phone: '',
      state: '',
      postal_code: '',
      professionType: '',
      subscription_plan_id: this.subPlanDetails?.id,
      status: "BLOCKED",
      type: this.subPlanDetails?.type,
      payload: { subscriptionId: this.subPlanDetails?.id }
    };

    console.log('Submitting Google signup:', submissionData);

    this.authService.register(submissionData).then(data => {
      console.log('Google Registration successful:', data);
      this.leadResponce = data;

      if (data) {
        this.isCompletedOne = true;
        this._dialog.open(SignupSuccessfullyComponent, {
          width: '30%',
          panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
          disableClose: true,
          data: data
        });
      }

      this.leadId = data.id;
      localStorage.setItem('signupstep', '2');
    });
  })
  .catch(error => {
    console.error('Error fetching Google user info:', error);
  });
}
/**** google sign up end */




  selectProfessionType() {
    console.log('Business Types--->', this.busineesTypes)
    this._dialog.open(SelectProfessionTypeComponent, {
      width: '45%',
      panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
      disableClose: true,
      data: this.busineesTypes
    })
    console.log('Select profession type clicked');
  }
  // continueToPay() {
  // }
  successfullySubscribed() {
    this._dialog.open(SuccessfullySubscribedComponent, {
      width: '40%',
      panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
      disableClose: true
    })
  }


  async addPersonalDetails() {
    console.log('Check ing --> 1')
   
    localStorage.setItem('incompletelogin', '0');
    if (this.subPlanDetails.type == "PROFESSIONAL") {
      this.subscriberDetailForm.get('ABN_ACN_number').clearValidators();
      this.subscriberDetailForm.get('businessName').clearValidators();
      this.subscriberDetailForm.get('ABN_ACN_number').updateValueAndValidity();
      this.subscriberDetailForm.get('businessName').updateValueAndValidity();
    }
    if (this.subPlanDetails.type == "SUPPLIER") {
      //console.log('Check ing Supplies--> 2')
      this.subscriberDetailForm.get('salutation').clearValidators();
      this.subscriberDetailForm.get('first_name').clearValidators();
      this.subscriberDetailForm.get('last_name').clearValidators();
      this.subscriberDetailForm.get('dob').clearValidators();
      this.subscriberDetailForm.get('gender').clearValidators();
      //console.log('Check ing Supplies--> 2.1')
      this.subscriberDetailForm.get('salutation').updateValueAndValidity();
      this.subscriberDetailForm.get('first_name').updateValueAndValidity();
      this.subscriberDetailForm.get('last_name').updateValueAndValidity();
      this.subscriberDetailForm.get('dob').updateValueAndValidity();
      this.subscriberDetailForm.get('gender').updateValueAndValidity();
      //console.log('Check ing Supplies--> 2.2')
    }
    if (this.subPlanDetails.type == "PRACTICE") {
      this.subscriberDetailForm.get('salutation').clearValidators();
      this.subscriberDetailForm.get('first_name').clearValidators();
      this.subscriberDetailForm.get('last_name').clearValidators();
      this.subscriberDetailForm.get('dob').clearValidators();
      this.subscriberDetailForm.get('gender').clearValidators();
      this.subscriberDetailForm.get('salutation').updateValueAndValidity();
      this.subscriberDetailForm.get('first_name').updateValueAndValidity();
      this.subscriberDetailForm.get('last_name').updateValueAndValidity();
      this.subscriberDetailForm.get('dob').updateValueAndValidity();
      this.subscriberDetailForm.get('gender').updateValueAndValidity();
    }
    console.log(this.subscriberDetailForm.value);
    if (this.subscriberDetailForm.invalid) {
      // this.toast.openSnackBar(
      //   'Enter Valid Details'
      // );
      //this.clearForm = true;
      this.subscriberDetailForm.markAllAsTouched();
      return;
    }

    this.spinner.show()
    //console.log("SUb Details--->",this.subscriberDetailForm.value);
    //this.subscriberDetailForm.value.profile_image = this.userPhoto
    // this.subscriberDetailForm.value.businessLogo = this.businessPhoto
    // console.log(this.leadId);
    // this.signUpData.payload = this.subscriberDetailForm.value
    // if(this.sub)
    if (this.subPlanDetails.type == "PROFESSIONAL") {
      this.profObj.date_of_birth = this.subscriberDetailForm.value.dob
      this.profObj.first_name = this.subscriberDetailForm.value.first_name
      this.profObj.middle_name = this.subscriberDetailForm.value.middle_name
      this.profObj.last_name = this.subscriberDetailForm.value.last_name
      this.profObj.gender = this.subscriberDetailForm.value.gender
      this.profObj.salutation = this.subscriberDetailForm.value.salutation
      this.profObj.profile_image = this.userPhoto
      await this.businessTyesService.updateProf(this.leadId, this.profObj)
      localStorage.setItem('signupstep', '3'); 
      this.spinner.hide()
      this.selectControl.setValue("CONTACT")
      this.showContactDetailsForm()
      this.isCompletedTwo = true
    }
    if (this.subPlanDetails.type == "SUPPLIER") {
      console.log('Check ing Supplier--> 3')
      this.supplierObj.logo = this.businessPhoto
      this.supplierObj.abn_number = this.subscriberDetailForm.value.ABN_ACN_number
      this.supplierObj.business_name = this.subscriberDetailForm.value.businessName
      console.log('Supplier Insert--> ',this.leadId)
      //this.supplierObj.subsciption_plan_id = this.subPlanDetails.id
      await this.businessTyesService.updateSupplier(this.leadId, this.supplierObj)
      localStorage.setItem('signupstep', '3'); 
      this.spinner.hide()
      this.selectControl.setValue("CONTACT")
      this.showContactDetailsForm()
      this.isCompletedTwo = true
    }
    if (this.subPlanDetails.type == "PRACTICE") {
      this.practiceObj.logo = this.businessPhoto
      this.practiceObj.abn_number = this.subscriberDetailForm.value.ABN_ACN_number
      this.practiceObj.business_name = this.subscriberDetailForm.value.businessName
      await this.businessTyesService.updatePractice(this.leadId, this.practiceObj)
      localStorage.setItem('signupstep', '3'); 
      this.spinner.hide()
      this.selectControl.setValue("CONTACT")
      this.showContactDetailsForm()
      this.isCompletedTwo = true
    }
    // this.detailsService.updateDetails( this.signUpData , this.leadId).then(data => {
    //   if (data) {
    //     this.toast.openSnackBar(
    //       'Your Details Submitted SuccessFully'
    //     );
    //     this.selectControl.setValue("CONTACT")
    //     this.showContactDetailsForm()
    //   }
    //   console.log(data)
    //   this.personalDetailsPayload = data.payload
    // })
  }
  getAllErrors(form: FormGroup | FormArray): { [key: string]: any; } | null {
    let hasError = false;
    const result = Object.keys(form.controls).reduce((acc, key) => {
        const control = form.get(key);
        const errors = (control instanceof FormGroup || control instanceof FormArray)
            ? this.getAllErrors(control)
            : control.errors;
        if (errors) {
            acc[key] = errors;
            hasError = true;
        }
        return acc;
    }, {} as { [key: string]: any; });
    return hasError ? result : null;
}


  async addProfessionalDetails() {
    //this.tgaFlip=false;
    localStorage.setItem('incompletelogin', '0');
    this.openpopup=true
    if (this.subPlanDetails.type == "PROFESSIONAL") {
      this.professionalDetailsForm.get('tga').clearValidators();
      this.professionalDetailsForm.get('tga').updateValueAndValidity();
    }
    if (this.subPlanDetails.type == "SUPPLIER") {
      console.log('Step ---------->1',this.tgaFlip)
      if(this.tgaFlip==true){
        this.tabFliperror=0;
        this.openpopup=false
      }else{
        this.tabFliperror=1;
        this.openpopup=true
      }
      this.professionalDetailsForm.get('pro_details_aphra_registration_number').clearValidators();
      this.professionalDetailsForm.get('drivingLicense').clearValidators();
      this.professionalDetailsForm.get('pro_details_aphra_registration_number').updateValueAndValidity();
      this.professionalDetailsForm.get('drivingLicense').updateValueAndValidity();
    }
    if (this.subPlanDetails.type == "PRACTICE") {
      this.professionalDetailsForm.get('tga').clearValidators();
      this.professionalDetailsForm.get('tga').updateValueAndValidity();
    }
    // this.bussObj.name = this.professionalDetailsForm.value.professionType
    // this.bussObj.status = "PENDING"
    // this.bussObj.sass_table_name = "directory_categories"
    // this.businessTyesService.addNewProfession(this.bussObj).then(data=>{
    //   console.log(data)
    // })
    // this.professionalDetailsForm.patchValue({
    //   professionType:scrollData.selEnterData
    // })
    
    console.log(this.professionalDetailsForm.value)
    if (this.professionalDetailsForm.invalid) {
      // this.toast.openSnackBar(
      //   'Enter Valid Details'
      // );
      //this.clearForm = true;
      console.log('mangal ', this.getAllErrors(this.professionalDetailsForm));
      this.professionalDetailsForm.markAllAsTouched();
      this.openpopup=false
      return;
    }
    //this.spinner.show()
    if (this.subPlanDetails.type == "PROFESSIONAL") {
      this.profProfDetails.profession_type = this.professionalDetailsForm.value.professionType
      this.profProfDetails.driving_licence = this.professionalDetailsForm.value.drivingLicense
      this.profProfDetails.pro_details_aphra_registration_number = this.professionalDetailsForm.value.pro_details_aphra_registration_number
      this.profProfDetails.directory_category_id = this.professionId
      const status = await this.businessTyesService.updateProfProfData(this.leadId, this.profProfDetails)
      console.log(status)
      if (status) {
        this.openpopup=false
        this.subPlanDetails.price_in_aud = 0;
        if (this.subPlanDetails.price_in_aud !== 0) {
          this._dialog.open(SignupPlanPaymentsComponent, {
            width: '30%',
            panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
            disableClose: true,
            data: {
              leadId: this.leadId,
              planDetails: this.subPlanDetails
            }
          })
        } else {
          this.toast.openSnackBar(
            'Your Details Submitted SuccessFully'
          );
          if (this.subPlanDetails.type == "PROFESSIONAL") {
            this.subObj.dental_professional_id = this.leadId
            delete this.subObj.dental_supplier_id
            delete this.subObj.dental_practice_id
            this.basicInfoTabService.getProfessional(this.leadId).subscribe(data => {
              console.log('This is RK')
              console.log(data)
              this.dentalData = data
              this.professionId = this.dentalData.directory_category_id
              console.log(this.dentalData)
      
              // this.basicInfoTabService.getDirCategoriesByPk(this.loginDetails.id).subscribe(data=>{
      
              //   this.userProfession = data
              //   console.log(this.userProfession)
              // });
      
              this.directoryAddForm.patchValue({
                name: this.dentalData.name,      
                profession_type: this.dentalData.profession_type,
                phone: this.dentalData.phone,
                email: this.dentalData.email,
                address: this.dentalData.address.addressName      
              });
              this.professinalObj.dental_professional_id = this.leadId
              this.professinalObj.name = this.directoryAddForm.value.name
              this.professinalObj.profession_type = this.directoryAddForm.value.profession_type
              //this.professinalObj.special_interests = this.interestList
              this.professinalObj.working_at = this.directoryAddForm.value.working_at
              this.professinalObj.designation = this.directoryAddForm.value.designation
              this.professinalObj.education = this.directoryAddForm.value.education
              this.professinalObj.type = this.subPlanDetails.type
              this.professinalObj.directory_category_id = this.professionId
              //this.professinalObj.banner_image = this.basicBanner
              this.professinalObj.profile_image = this.dentalData.profile_image
              this.professinalObj.hobbies = this.directoryAddForm.value.hobbies
              this.professinalObj.university_school = this.directoryAddForm.value.university_school
              this.professinalObj.email = this.directoryAddForm.value.email
              this.professinalObj.phone = this.directoryAddForm.value.phone
              this.professinalObj.address = this.directoryAddForm.value.address
              this.professinalObj.alt_phone = this.directoryAddForm.value.alternative_phone
              this.professinalObj.latitude = this.dentalData.address.latitude
              this.professinalObj.longitude = this.dentalData.address.longitude
              this.professinalObj.pincode = this.dentalData.address.zipcode
              this.basicInfoTabService.addBasicInfoProfe(this.professinalObj).then(data => {
                console.log(data)
              })
      
            });
          }
          if (this.subPlanDetails.type == "SUPPLIER") {
            this.subObj.dental_supplier_id = this.leadId
            delete this.subObj.dental_professional_id
            delete this.subObj.dental_practice_id
          }
          if (this.subPlanDetails.type == "PRACTICE") {
            this.subObj.dental_practice_id = this.leadId
            delete this.subObj.dental_supplier_id
            delete this.subObj.dental_professional_id
          }
          // this.userName
          this.subObj.subscription_plan_id = this.subPlanDetails.id
          this.subObj.starts_at = _moment().toDate();
          if(this.subPlanDetails.priceExten == "Monthly"){
            this.subObj.expires_at = _moment().add(30, 'd').toDate();
          }else{
            this.subObj.expires_at = _moment().add(365, 'd').toDate();
          }
         
          //this.subObj.status =  "PENDING"
          this.subObj.plan_type = this.subPlanDetails.plan_type
          this.subObj.total_amount = this.subPlanDetails.price_in_aud
          console.log(this.subObj)
          await this.catalogueService.addFreePlan(this.subObj).subscribe(data => {
            console.log(data)
            if (data.id) {
              this.selectControl.setValue("OTHER")
              this.showOtherDetailsForm()
              this.isCompletedFour = true
            }
          })
          // if(){
          // }
        }
      }
    }
    
    if (this.subPlanDetails.type == "SUPPLIER") {
      console.log('Step ---------->2')
      this.profSupplierDetails.profession_type = this.professionalDetailsForm.value.professionType
      this.profSupplierDetails.tga_number = this.professionalDetailsForm.value.tga
      // this.profProfDetails.pro_details_aphra_registration_number = this.professionalDetailsForm.value.pro_details_aphra_registration_number
      this.profSupplierDetails.directory_category_id = this.professionId
      console.log('Step ---------->3',this.leadId, this.profSupplierDetails)
      const status = await this.businessTyesService.updateSupplierProfData(this.leadId, this.profSupplierDetails)
      //console.log(status)
      if (status) {
        this.openpopup=false
        this.subPlanDetails.price_in_aud = 0;
        if (this.subPlanDetails.price_in_aud !== 0) {
          this._dialog.open(SignupPlanPaymentsComponent, {
            width: '30%',
            panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
            disableClose: true,
            data: {
              leadId: this.leadId,
              planDetails: this.subPlanDetails
            }
          })
        } else {
          this.toast.openSnackBar(
            'Your Details Submitted SuccessFully'
          );
          if (this.subPlanDetails.type == "PROFESSIONAL") {
            this.subObj.dental_professional_id = this.leadId
            delete this.subObj.dental_supplier_id
            delete this.subObj.dental_practice_id
          }
          if (this.subPlanDetails.type == "SUPPLIER") {
            this.subObj.dental_supplier_id = this.leadId
            delete this.subObj.dental_professional_id
            delete this.subObj.dental_practice_id
            this.basicInfoTabService.getSupplier(this.leadId).subscribe(data => {
              this.dentalData = data
              console.log(this.dentalData)
              this.professionId = this.dentalData.directory_category_id
              this.directoryAddForm.patchValue({
                company_name: this.dentalData.business_name,
                abn_number: this.dentalData.abn_number,      
                profession_type: this.dentalData.profession_type,
                phone: this.dentalData.phone,
                email: this.dentalData.email,
                name: this.dentalData.name,
                address: this.dentalData.address.addressName
              });
              this.dirObj.type = this.subPlanDetails.type
              this.dirObj.name = this.directoryAddForm.value.name
              this.dirObj.company_name = this.directoryAddForm.value.company_name
              this.dirObj.profession_type = this.directoryAddForm.value.profession_type
              this.dirObj.abn_acn = this.directoryAddForm.value.abn_number
              //this.professinalObj.directory_category_id = this.professionId
              this.dirObj.directory_category_id = this.professionId
              //this.dirObj.banner_image = this.basicBanner
              this.dirObj.logo = this.dentalData.logo
              this.dirObj.email = this.directoryAddForm.value.email
              this.dirObj.phone = this.directoryAddForm.value.phone
              this.dirObj.address = this.directoryAddForm.value.address
              this.dirObj.alt_phone = this.directoryAddForm.value.alternative_phone
              this.dirObj.latitude = this.dentalData.address.latitude
              this.dirObj.longitude = this.dentalData.address.longitude
              this.dirObj.pincode = this.dentalData.address.zipcode
              console.log(this.dirObj.directory_category_id)
              this.basicInfoTabService.addBasicInfo(this.dirObj).then(data => {
                console.log(data)
                if (data) {
                  this.toast.openSnackBar(
                    'Your details added successfully'
                  );
                }
              })
            });
          }
          if (this.subPlanDetails.type == "PRACTICE") {
            this.subObj.dental_practice_id = this.leadId
            delete this.subObj.dental_supplier_id
            delete this.subObj.dental_professional_id
          }
          // this.userName
          this.subObj.subscription_plan_id = this.subPlanDetails.id
          this.subObj.starts_at = _moment().toDate();
          if(this.subPlanDetails.priceExten == "Monthly"){
            this.subObj.expires_at = _moment().add(30, 'd').toDate();
          }else{
            this.subObj.expires_at = _moment().add(365, 'd').toDate();
          }
          //this.subObj.expires_at = _moment().add(this.subPlanDetails.tenure_in_days, 'd').toDate();
          //this.subObj.status =  "PENDING"
          this.subObj.plan_type = this.subPlanDetails.plan_type
          this.subObj.total_amount = this.subPlanDetails.price_in_aud
          console.log(this.subObj)
          await this.catalogueService.addFreePlan(this.subObj).subscribe(data => {
            console.log(data)
            if (data.id) {
              this.selectControl.setValue("OTHER")
              this.showOtherDetailsForm()
              this.isCompletedFour = true
            }
          })
          // if(){
          // }
        }
      }
      // this.selectControl.setValue("OTHER")
      // this.showOtherDetailsForm()
    }
    if (this.subPlanDetails.type == "PRACTICE") {
      this.profPracticeDetails.profession_type = this.professionalDetailsForm.value.professionType
      this.profPracticeDetails.driving_licence = this.professionalDetailsForm.value.drivingLicense
      this.profPracticeDetails.pro_details_aphra_registration_number = this.professionalDetailsForm.value.pro_details_aphra_registration_number
      this.profPracticeDetails.directory_category_id = this.professionId
      const status = await this.businessTyesService.updatePracticeProfData(this.leadId, this.profPracticeDetails)
      console.log(status)
      if (status) {
        this.openpopup=false
        this.subPlanDetails.price_in_aud = 0;
        if (this.subPlanDetails.price_in_aud !== 0) {
          this._dialog.open(SignupPlanPaymentsComponent, {
            width: '30%',
            panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
            disableClose: true,
            data: {
              leadId: this.leadId,
              planDetails: this.subPlanDetails
            }
          })
        } else {
          this.toast.openSnackBar(
            'Your Details Submitted SuccessFully'
          );
          if (this.subPlanDetails.type == "PROFESSIONAL") {
            this.subObj.dental_professional_id = this.leadId
            delete this.subObj.dental_supplier_id
            delete this.subObj.dental_practice_id
          }
          if (this.subPlanDetails.type == "SUPPLIER") {
            this.subObj.dental_supplier_id = this.leadId
            delete this.subObj.dental_professional_id
            delete this.subObj.dental_practice_id
          }
          if (this.subPlanDetails.type == "PRACTICE") {
            this.subObj.dental_practice_id = this.leadId
            delete this.subObj.dental_supplier_id
            delete this.subObj.dental_professional_id
            this.basicInfoTabService.getPractice(this.leadId).subscribe(data => {
              this.dentalData = data
              console.log(this.dentalData)
              this.professionId = this.dentalData.directory_category_id
      
              this.directoryAddForm.patchValue({
                company_name: this.dentalData.business_name,
                abn_number: this.dentalData.abn_number,
                profession_type: this.dentalData.profession_type,
                phone: this.dentalData.phone,
                email: this.dentalData.email,
                name: this.dentalData.name,
                address: this.dentalData.address.addressName
      
              });
              
              this.dirObj.type = this.subPlanDetails.type
              this.dirObj.name = this.directoryAddForm.value.name
              this.dirObj.company_name = this.directoryAddForm.value.company_name
              this.dirObj.profession_type = this.directoryAddForm.value.profession_type
              this.dirObj.abn_acn = this.directoryAddForm.value.abn_number
              //this.professinalObj.directory_category_id = this.professionId
              this.dirObj.directory_category_id = this.professionId
              //this.dirObj.banner_image = this.basicBanner
              this.dirObj.logo = this.dentalData.logo
              this.dirObj.email = this.directoryAddForm.value.email
              this.dirObj.phone = this.directoryAddForm.value.phone
              this.dirObj.address = this.directoryAddForm.value.address
              this.dirObj.alt_phone = this.directoryAddForm.value.alternative_phone
              this.dirObj.latitude = this.dentalData.address.latitude
              this.dirObj.longitude = this.dentalData.address.longitude
              this.dirObj.pincode = this.dentalData.address.zipcode
              console.log(this.dirObj.directory_category_id)
              this.basicInfoTabService.addBasicInfo(this.dirObj).then(data => {
                console.log(data)
                if (data) {
                  this.toast.openSnackBar(
                    'Your details added successfully'
                  );
                }
              })
      
            });
          }
          // this.userName
          this.subObj.subscription_plan_id = this.subPlanDetails.id
          this.subObj.starts_at = _moment().toDate();
          if(this.subPlanDetails.priceExten == "Monthly"){
            this.subObj.expires_at = _moment().add(30, 'd').toDate();
          }else{
            this.subObj.expires_at = _moment().add(365, 'd').toDate();
          }
          //this.subObj.expires_at = _moment().add(this.subPlanDetails.tenure_in_days, 'd').toDate();
          //this.subObj.status =  "PENDING"
          this.subObj.plan_type = this.subPlanDetails.plan_type
          this.subObj.total_amount = this.subPlanDetails.price_in_aud
          console.log(this.subObj)
          await this.catalogueService.addFreePlan(this.subObj).subscribe(data => {
            console.log(data)
            if (data.id) {
              this.selectControl.setValue("OTHER")
              this.showOtherDetailsForm()
              this.isCompletedFour = true
            }
          })
          // if(){
          // }
        }
      }
      // this.selectControl.setValue("OTHER")
      // this.showOtherDetailsForm()
    }
    // console.log(this.professionalDetailsForm.value);
    // this.professionalDetailsForm.value.first_name = this.contactDetailsPayload.first_name
    // this.professionalDetailsForm.value.middle_name = this.contactDetailsPayload.middle_name
    // this.professionalDetailsForm.value.last_name = this.contactDetailsPayload.last_name
    // this.professionalDetailsForm.value.gender = this.contactDetailsPayload.gender
    // this.professionalDetailsForm.value.dob = this.contactDetailsPayload.dob
    // this.professionalDetailsForm.value.salutation = this.contactDetailsPayload.salutation
    // this.professionalDetailsForm.value.businessName = this.contactDetailsPayload.businessName
    // this.professionalDetailsForm.value.ABN_ACN_number = this.contactDetailsPayload.ABN_ACN_number
    // this.professionalDetailsForm.value.profile_image = this.contactDetailsPayload.profile_image
    // this.professionalDetailsForm.value.businessLogo = this.contactDetailsPayload.businessLogo
    // this.professionalDetailsForm.value.fName = this.contactDetailsPayload.fName
    // this.professionalDetailsForm.value.lName = this.contactDetailsPayload.lName
    // this.professionalDetailsForm.value.mName = this.contactDetailsPayload.mName
    // this.professionalDetailsForm.value.faxNumber = this.contactDetailsPayload.faxNumber
    // this.professionalDetailsForm.value.businessEmail = this.contactDetailsPayload.businessEmail
    // this.professionalDetailsForm.value.businessPhoneNumber = this.contactDetailsPayload.businessPhoneNumber
    // this.professionalDetailsForm.value.contactName = this.contactDetailsPayload.contactName
    // this.professionalDetailsForm.value.emailTwo = this.contactDetailsPayload.emailTwo
    // this.professionalDetailsForm.value.phoneNoTwo = this.contactDetailsPayload.phoneNoTwo
    //this.professionalDetailsForm.value.emailtwo = this.contactDetailsPayload.emailtwo
    // this.professionalDetailsForm.value.phoneNo = this.contactDetailsPayload.phoneNo
    // this.professionalDetailsForm.value.altEmail = this.contactDetailsPayload.altEmail
    // this.professionalDetailsForm.value.altPhoneNo = this.contactDetailsPayload.altPhoneNo
    // this.address.addressName = this.contactDetailsPayload.address.addressName
    // this.address.latitude = this.contactDetailsPayload.address.latitude
    // this.address.longitude = this.contactDetailsPayload.address.longitude
    // this.address.address_line_one = this.contactDetailsPayload.address.address_line_one
    // this.address.address_line_two = this.contactDetailsPayload.address.address_line_two
    // this.address.land_mark = this.contactDetailsPayload.address.land_mark
    // this.address.city = this.contactDetailsPayload.address.city
    // this.address.state = this.contactDetailsPayload.address.state
    // this.address.country = this.contactDetailsPayload.address.country
    // this.address.zipcode = this.contactDetailsPayload.address.zipcode
    // this.professionalDetailsForm.value.address = this.address
    // this.professionalDetailsForm.value.professionId = this.professionId
    // this.professionalDetailsForm.value.address.address_line_one = this.contactDetailsPayload.address.address_line_one
    // this.professionalDetailsForm.value.address.address_line_two = this.contactDetailsPayload.address.address_line_two
    // this.professionalDetailsForm.value.address.land_mark = this.contactDetailsPayload.address.land_mark
    // this.professionalDetailsForm.value.address.city = this.contactDetailsPayload.address.city
    // this.professionalDetailsForm.value.address.state = this.contactDetailsPayload.address.state
    // this.professionalDetailsForm.value.country = this.contactDetailsPayload.country
    // this.professionalDetailsForm.value.address.zipcode = this.contactDetailsPayload.address.zipcode
    // this.professionalDetailsForm.value.resume_attachment = this.fileUrl
    //this.professionalDetailsForm.value.registration_certificate_attachment = this.fileTWoUrl
    //this.professionalDetailsForm.value.dentalCertificate = this.fileThreeUrl
    // this.professionalDetailsForm.value.benefits = this.subPlanDetails.benefits
    // this.professionalDetailsForm.value.description = this.subPlanDetails.description
    // this.professionalDetailsForm.value.subscriptionId = this.subPlanDetails.id
    // this.professionalDetailsForm.value.subscriptionName = this.subPlanDetails.name
    // this.professionalDetailsForm.value.price_in_aud = this.subPlanDetails.price_in_aud
    // this.professionalDetailsForm.value.price_in_usd = this.subPlanDetails.price_in_usd
    // this.professionalDetailsForm.value.tenure_in_days = this.subPlanDetails.tenure_in_days
    // this.professionalDetailsForm.value.terms_and_conditions = this.subPlanDetails.terms_and_conditions
    // this.professionalDetailsForm.value.subscriptionType = this.subPlanDetails.type
    // this.professionalDetailsForm.value.tenure_type = this.subPlanDetails.tenure_type
    // this.bank_details.bank_name = this.professionalDetailsForm.value.bank_name
    // this.bank_details.branch_name = this.professionalDetailsForm.value.branch_name
    // this.bank_details.account_holder_name = this.professionalDetailsForm.value.account_holder_name
    // this.bank_details.account_number = this.professionalDetailsForm.value.account_number
    // this.bank_details.bsb = this.professionalDetailsForm.value.bsb
    // this.address.address_line_two = this.contactInformationForm.value.address_line_two
    // this.address.land_mark = this.contactInformationForm.value.land_mark
    // this.address.city = this.contactInformationForm.value.city
    // this.address.state = this.contactInformationForm.value.state
    // this.address.country = this.contactInformationForm.value.country
    // this.address.zipcode = this.contactInformationForm.value.zipcode
    // this.professionalDetailsForm.value.bank_details = this.bank_details
    // this.professionalDetailsForm.value.bank_details.bank_name = this.professionalDetailsForm.value.bank_name
    // this.professionalDetailsForm.value.bank_details.branch_name = this.professionalDetailsForm.value.branch_name
    // this.professionalDetailsForm.value.bank_details.account_holder_name = this.professionalDetailsForm.value.account_holder_name
    // this.professionalDetailsForm.value.bank_details.account_number = this.professionalDetailsForm.value.account_number
    // this.professionalDetailsForm.value.bank_details.bsb = this.professionalDetailsForm.value.bsb
    // delete this.professionalDetailsForm.value.bank_name
    // delete this.professionalDetailsForm.value.branch_name
    // delete this.professionalDetailsForm.value.account_holder_name
    // delete this.professionalDetailsForm.value.account_number
    // delete this.professionalDetailsForm.value.bsb
    // console.log(this.leadId);
    // this.signUpData.payload = this.professionalDetailsForm.value
    // this.signUpData.profile_status = true
    // this.detailsService.updateDetails(this.signUpData, this.leadId).then(data => {
    //   console.log(data)
    //   this.professinalPayload = data.payload
    //   if (data) {
    //     this._dialog.open ( SignupPaymentSuccessComponent, {
    //       width: '40%',
    //       panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
    //       disableClose: true,
    //       data: this.subPlanDetails
    //     })
    //     this.toast.openSnackBar(
    //       'Your Details Submitted SuccessFully'
    //     );
    //   }
    // })
  }
  onSelectFile(event) {
    console.log(event[0])
    const formData = new FormData();
    formData.append('directory', 'project');
    formData.append('file', event[0]);
    formData.append('Content-Type', 'application/json');
    formData.append('accept', 'application/json');
    console.log(formData)
    this.mediaService.uploadMedia(formData).subscribe(response => {
      console.log(response)
      this.fileUrl = response
      //this.fileName = response.name
      this.professionalDetailsForm.patchValue({
        resume_attachment: response.name
      })
    });
  }
  onSelectFileTwo(event) {
    console.log(event[0])
    const formData = new FormData();
    formData.append('directory', 'project');
    formData.append('file', event[0]);
    formData.append('Content-Type', 'application/json');
    formData.append('accept', 'application/json');
    console.log(formData)
    this.mediaService.uploadMedia(formData).subscribe(response => {
      console.log(response)
      this.fileTWoUrl = response
      this.professionalDetailsForm.patchValue({
        registration_certificate_attachment: response.name
      })
    });
  }
  onSelectFileThree(event) {
    console.log(event[0])
    const formData = new FormData();
    formData.append('directory', 'project');
    formData.append('file', event[0]);
    formData.append('Content-Type', 'application/json');
    formData.append('accept', 'application/json');
    console.log(formData)
    this.mediaService.uploadMedia(formData).subscribe(response => {
      console.log(response)
      this.fileThreeUrl = response.url
      this.professionalDetailsForm.patchValue({
        dentalCertificate: response.name
      })
    });
  }
  onSelectFileDp(event) {
    this.spinner.show()
    console.log(event[0])
    const formData = new FormData();
    formData.append('directory', 'project');
    formData.append('file', event[0]);
    formData.append('Content-Type', 'application/json');
    formData.append('accept', 'application/json');
    console.log(formData)
    this.mediaService.uploadMedia(formData).subscribe(response => {
      console.log(response)
      this.spinner.hide()
      this.userPhoto = response
      // this.subscriberDetailForm.patchValue({
      //   userDp : response.url
      // })
    });
  }
  onSelectFileBusinessLogo(event) {
    this.spinner.show()
    console.log(event[0])
    //   this.subscriberDetailForm.patchValue({
    //     businessLogo: event[0],
    //  })
    //this.subscriberDetailForm.get('businessLogo').setValue(event[0].name);
    const formData = new FormData();
    formData.append('directory', 'project');
    formData.append('file', event[0]);
    formData.append('Content-Type', 'application/json');
    formData.append('accept', 'application/json');
    console.log(formData)
    this.mediaService.uploadMedia(formData).subscribe(response => {
      console.log(response)
      this.spinner.hide()
      this.businessPhoto = response
      // this.subscriberDetailForm.patchValue({
      //   userDp : response.url
      // })
    });
  }
  termsPop(tcData) {
    this._dialog.open(TermsPopUpComponent, {
      width: '40%',
      panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
      data: tcData
    })
  }
  //   openModal() {
  //     const modalRef = this.modalService.open(AppModalComponent);
  //     modalRef.componentInstance.emitService.subscribe((emmitedValue) => {
  //         // do sth with emmitedValue
  //     });
  // }

  regConfirmPop() {
    this.router.navigate(['/'])
    this._dialog.open(LoginReqComponent, {
      width: '25%',
      panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
      disableClose: true,
    })
  }
  
  async addOtherDetails() {

  // console.log(this.sellProducts.value)
  console.log(this.otherDetailsForm.value)
  
   if(this.sellSecondHandSupplies.value){

    this.otherDetailsForm.get('bank_name').setValidators([Validators.required]);
    this.otherDetailsForm.get('account_holder_name').setValidators([Validators.required,Validators.pattern('.*\\S.*[a-zA-Z,./-0-9  ]')]);
    this.otherDetailsForm.get('account_number').setValidators([Validators.required]);
    this.otherDetailsForm.get('bsb').setValidators([Validators.required]);


    this.otherDetailsForm.get('bank_name').updateValueAndValidity();
    this.otherDetailsForm.get('account_holder_name').updateValueAndValidity();
    this.otherDetailsForm.get('account_number').updateValueAndValidity();
    this.otherDetailsForm.get('bsb').updateValueAndValidity();


   }else{


    this.otherDetailsForm.get('bank_name').clearValidators();
    this.otherDetailsForm.get('account_holder_name').clearValidators();
    this.otherDetailsForm.get('account_number').clearValidators();
    this.otherDetailsForm.get('bsb').clearValidators();


    this.otherDetailsForm.get('bank_name').updateValueAndValidity();
    this.otherDetailsForm.get('account_holder_name').updateValueAndValidity();
    this.otherDetailsForm.get('account_number').updateValueAndValidity();
    this.otherDetailsForm.get('bsb').updateValueAndValidity();

   }



    if (this.otherDetailsForm.invalid) {
      // this.toast.openSnackBar(
      //   'Enter Valid Bank Details'
      // );
      //this.clearForm = true;
      this.otherDetailsForm.markAllAsTouched();
      return;
    }
    console.log(this.otherDetailsForm.value)
    console.log(this.sellProducts.value)
    if (this.subPlanDetails.type == "PROFESSIONAL") {
      this.profBankDetails.bank_details.bank_name = this.otherDetailsForm.value.bank_name
      this.profBankDetails.bank_details.account_number = this.otherDetailsForm.value.account_number
      this.profBankDetails.bank_details.account_holder_name = this.otherDetailsForm.value.account_holder_name
      this.profBankDetails.bank_details.bsb = this.otherDetailsForm.value.bsb
      this.profBankDetails.second_hand = this.otherDetailsForm.value.sellSecondHandSupplies
      const bankStatus = await this.businessTyesService.updateProfOtherData(this.leadId, this.profBankDetails)
      // console.log(iii)
      if (bankStatus) {
        this.router.navigate(['/'])
        this._dialog.open(LoginReqComponent, {
          width: '25%',
          panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
          disableClose: true,
        })
      }
    }
    if (this.subPlanDetails.type == "SUPPLIER") {
      this.supplierBankDetails.bank_details.bank_name = this.otherDetailsForm.value.bank_name
      this.supplierBankDetails.bank_details.account_number = this.otherDetailsForm.value.account_number
      this.supplierBankDetails.bank_details.account_holder_name = this.otherDetailsForm.value.account_holder_name
      this.supplierBankDetails.bank_details.bsb = this.otherDetailsForm.value.bsb
      this.supplierBankDetails.second_hand = this.otherDetailsForm.value.sellSecondHandSupplies
      this.supplierBankDetails.sell_products = this.otherDetailsForm.value.sellProducts
      const bankStatus = await this.businessTyesService.updateSupplierOtherData(this.leadId, this.supplierBankDetails)
      if (bankStatus) {
        this.router.navigate(['/'])
        this._dialog.open(LoginReqComponent, {
          width: '30%',
          panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
          disableClose: true,
        })
      }
    }
    if (this.subPlanDetails.type == "PRACTICE") {
      this.practiceBankDetails.bank_details.bank_name = this.otherDetailsForm.value.bank_name
      this.practiceBankDetails.bank_details.account_number = this.otherDetailsForm.value.account_number
      this.practiceBankDetails.bank_details.account_holder_name = this.otherDetailsForm.value.account_holder_name
      this.practiceBankDetails.bank_details.bsb = this.otherDetailsForm.value.bsb
      this.practiceBankDetails.second_hand = this.otherDetailsForm.value.sellSecondHandSupplies
      const bankStatus = await this.businessTyesService.updatePracticeOtherData(this.leadId, this.practiceBankDetails)
      if (bankStatus) {
        this.router.navigate(['/'])
        this._dialog.open(LoginReqComponent, {
          width: '30%',
          panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
          disableClose: true,
        })
      }
    }
    // this.otherDetailsForm.value.first_name = this.professinalPayload.first_name
    //   this.otherDetailsForm.value.middle_name = this.professinalPayload.middle_name
    //   this.otherDetailsForm.value.last_name = this.professinalPayload.last_name
    //   this.otherDetailsForm.value.gender = this.professinalPayload.gender
    //   this.otherDetailsForm.value.dob = this.professinalPayload.dob
    //   this.otherDetailsForm.value.salutation = this.professinalPayload.salutation
    //   this.otherDetailsForm.value.businessName = this.professinalPayload.businessName
    //   this.otherDetailsForm.value.ABN_ACN_number = this.professinalPayload.ABN_ACN_number
    //   this.otherDetailsForm.value.profile_image = this.professinalPayload.profile_image
    //   this.otherDetailsForm.value.businessLogo = this.professinalPayload.businessLogo
    //   this.otherDetailsForm.value.fName = this.professinalPayload.fName
    //   this.otherDetailsForm.value.lName = this.professinalPayload.lName
    //   this.otherDetailsForm.value.mName = this.professinalPayload.mName
    //   this.otherDetailsForm.value.faxNumber = this.professinalPayload.faxNumber
    //   this.otherDetailsForm.value.businessEmail = this.professinalPayload.businessEmail
    //   this.otherDetailsForm.value.businessPhoneNumber = this.professinalPayload.businessPhoneNumber
    //   this.otherDetailsForm.value.contactName = this.professinalPayload.contactName
    //   this.otherDetailsForm.value.emailTwo = this.professinalPayload.emailTwo
    //this.otherDetailsForm.value.phoneNoTwo = this.professinalPayload.phoneNoTwo
    //this.professionalDetailsForm.value.emailtwo = this.contactDetailsPayload.emailtwo
    // this.professionalDetailsForm.value.phoneNo = this.contactDetailsPayload.phoneNo
    // this.otherDetailsForm.value.altEmail = this.professinalPayload.altEmail
    // this.otherDetailsForm.value.altPhoneNo = this.professinalPayload.altPhoneNo
    // this.address.addressName = this.professinalPayload.address.addressName
    // this.address.latitude = this.professinalPayload.address.latitude
    // this.address.longitude = this.professinalPayload.address.longitude
    // this.address.address_line_one = this.professinalPayload.address.address_line_one
    // this.address.address_line_two = this.professinalPayload.address.address_line_two
    // this.address.land_mark = this.professinalPayload.address.land_mark
    // this.address.city = this.professinalPayload.address.city
    // this.address.state = this.professinalPayload.address.state
    // this.address.country = this.professinalPayload.address.country
    // this.address.zipcode = this.professinalPayload.address.zipcode
    // this.otherDetailsForm.value.address = this.address
    // this.professionalDetailsForm.value.address.address_line_one = this.contactDetailsPayload.address.address_line_one
    // this.professionalDetailsForm.value.address.address_line_two = this.contactDetailsPayload.address.address_line_two
    // this.professionalDetailsForm.value.address.land_mark = this.contactDetailsPayload.address.land_mark
    // this.professionalDetailsForm.value.address.city = this.contactDetailsPayload.address.city
    // this.professionalDetailsForm.value.address.state = this.contactDetailsPayload.address.state
    // this.professionalDetailsForm.value.country = this.contactDetailsPayload.country
    // this.professionalDetailsForm.value.address.zipcode = this.contactDetailsPayload.address.zipcode
    // this.professionalDetailsForm.value.resume_attachment = this.fileUrl
    //this.professionalDetailsForm.value.registration_certificate_attachment = this.fileTWoUrl
    //this.professionalDetailsForm.value.dentalCertificate = this.fileThreeUrl
    // this.otherDetailsForm.value.benefits = this.professinalPayload.benefits
    // this.otherDetailsForm.value.description = this.professinalPayload.description
    // this.otherDetailsForm.value.subscriptionId = this.professinalPayload.subscriptionId
    // this.otherDetailsForm.value.subscriptionName = this.professinalPayload.subscriptionName
    // this.otherDetailsForm.value.price_in_aud = this.professinalPayload.price_in_aud
    // this.otherDetailsForm.value.price_in_usd = this.professinalPayload.price_in_usd
    // this.otherDetailsForm.value.tenure_in_days = this.professinalPayload.tenure_in_days
    // this.otherDetailsForm.value.terms_and_conditions = this.professinalPayload.terms_and_conditions
    // this.otherDetailsForm.value.subscriptionType = this.professinalPayload.subscriptionType
    // this.otherDetailsForm.value.tenure_in_days = this.professinalPayload.tenure_in_days
    // this.otherDetailsForm.value.professionType = this.professinalPayload.professionType
    // this.otherDetailsForm.value.professionId = this.professinalPayload.professionId
    // this.otherDetailsForm.value.drivingLicense = this.professinalPayload.drivingLicense
    // this.otherDetailsForm.value.pro_details_aphra_registration_number = this.professinalPayload.pro_details_aphra_registration_number
    // this.otherDetailsForm.value.tga = this.professinalPayload.tga
    //  this.bank_details.bank_name = this.otherDetailsForm.value.bank_name
    // this.bank_details.account_holder_name = this.otherDetailsForm.value.account_holder_name
    // this.bank_details.account_number = this.otherDetailsForm.value.account_number
    // this.bank_details.bsb = this.otherDetailsForm.value.bsb
    //  this.otherDetailsForm.value.bank_details = this.bank_details
    // this.professionalDetailsForm.value.bank_details.bank_name = this.professionalDetailsForm.value.bank_name
    // this.professionalDetailsForm.value.bank_details.account_holder_name = this.professionalDetailsForm.value.account_holder_name
    // this.professionalDetailsForm.value.bank_details.account_number = this.professionalDetailsForm.value.account_number
    // this.professionalDetailsForm.value.bank_details.bsb = this.professionalDetailsForm.value.bsb
    // delete this.otherDetailsForm.value.bank_name
    // delete this.otherDetailsForm.value.account_holder_name
    // delete this.otherDetailsForm.value.account_number
    // delete this.otherDetailsForm.value.bsb
    // this.signUpData.payload = this.otherDetailsForm.value
    // this.detailsService.updateDetails(this.signUpData, this.leadId).then(data => {
    //   console.log(data)
    //   //this.professinalPayload = data.update_leads_by_pk.payload
    //   if (data) {
    //     this.toast.openSnackBar(
    //       'Your Details Submitted SuccessFully'
    //     );
    //     this.router.navigate(['/'])
    //     this._dialog.open ( LoginReqComponent, {
    //       width: '40%',
    //       panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
    //       disableClose: true,
    //     })
    //   }
    // })
  }
  displayBank() {
    this.showHide = !this.showHide
  }

  disButton(){

    this.btnShow = !this.btnShow

  }
  // clickToCall() {
  //   this.mapsAPILoader.load().then(() => {
  //     //this.setCurrentLocation();
  //     //this.setCurrentPosition()
  //     this.geoCoder = new google.maps.Geocoder;
  //     let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement);
  //     autocomplete.addListener("place_changed", () => {
  //       this.ngZone.run(() => {
  //         let place: google.maps.places.PlaceResult = autocomplete.getPlace();
  //         this.addressName = place
  //         console.log(this.addressName)
  //         this.pincode = this.addressName.address_components.slice(-1)[0]
  //         this.countryName = this.addressName.address_components.slice(-2)[0]
  //         this.stateName = this.addressName.address_components.slice(-3)[0]
  //         console.log(this.pincode)
  //         this.contactInformationForm.patchValue({
  //           state: this.stateName.long_name,
  //           country: this.countryName.long_name,
  //           zipcode: this.pincode.long_name
  //         })
  //         // if (place.geometry === undefined || place.geometry === null) {
  //         //   return;
  //         // }
  //         this.latitude = place.geometry.location.lat();
  //         this.longitude = place.geometry.location.lng();
  //         this.zoom = 12;
  //       });
  //     });
  //   })
  //   // private setCurrentPosition() {
  //   //   if ("geolocation" in navigator) {
  //   //     navigator.geolocation.getCurrentPosition((position) => {
  //   //       console.log(position)
  //   //       this.latitude = position.coords.latitude;
  //   //       this.longitude = position.coords.longitude;
  //   //       this.zoom = 12;
  //   //     });
  //   //   }
  //   // }
  // }

  tgaCon(ev: any) {

    console.log(ev);
    this.tgaFlip = ev.value;
    if(this.tgaFlip==true){
      this.tabFliperror=0;
      this.professionalDetailsForm.controls.tga.clearValidators();
      this.professionalDetailsForm.controls.tga.updateValueAndValidity();
    }else{
      this.tabFliperror=1;
      this.professionalDetailsForm.controls.tga.setValidators([Validators.required, Validators.pattern('.*\\S.*[a-zA-Z,./-0-9  ]')]);
      this.professionalDetailsForm.controls.tga.updateValueAndValidity();
    }
    this.openpopup=false
  }
  mmuu() {
  }
  function_one() {
  }
  function_two() {
  }
  eventHandler(event) {
    if (event.target.value.length == this.specificLength && (event.code == "Backspace" || event.code == "Delete")) {
      return false;
    }
    return true;
  }

  getAge(DOB) {
    var today = new Date();
    var birthDate = new Date(DOB);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }    
    return age;
}

getValidDob(dob){
    //console.log('Dob--->', dob)
    var dt = dob.value._d;
    this.validDob = this.getAge(dt)
    //console.log('Dob Age--->', this.validDob)
    if(this.validDob < 18){
      this.subscriberDetailForm.value.dob.validator = true;
      this.subscriberDetailForm.patchValue({
        dob: ''
      });
    }
}


// Handle tab changesonTabChange(event: MatTabChangeEvent) {
  onTabChange(event: MatTabChangeEvent) {
    const isOtherTab = event.index === this.typeBus.length;
    const customControl = this.signUpDetailsForm.get('customBusinessType');
    
    if (isOtherTab) {
      customControl.setValidators([Validators.required]);
      this.signUpDetailsForm.get('professionType').reset();
    } else {
      customControl.clearValidators();
      customControl.reset();
    }
    customControl.updateValueAndValidity();
  }

// Handle toggle selection
onProfessionTypeChange() {
  // Automatically validate when a toggle is selected
  this.signUpDetailsForm.get('professionType').updateValueAndValidity();
}

allowOnlyAlphabets(event: KeyboardEvent) {
  const pattern = /^[a-zA-Z\s]*$/;
  const inputChar = String.fromCharCode(event.keyCode);

  if (!pattern.test(inputChar)) {
    event.preventDefault(); // Block invalid character
  }
}


}
